export default __webpack_public_path__ + "static/media/Metropolis1920-Regular.bbf1ec18.otf";